import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DpTableComponent } from '../../../common-component/dp-table/dp-table.component';
import { SerialNoCellComponent } from '../../../table-cell/serial-no-cell.component';
import { ReviewDataService } from '../../../services/raintree/Transmission/review-data.service';
import { ActiveCellComponent } from '../../../table-cell/active-cell-component';
import { DateFormatCellComponent } from '../../../table-cell/date-format-cell.component';
import { CountCellComponent } from '../../../table-cell/count-cell.component';
import { MatDialog } from '@angular/material/dialog';
import { ManageDialogueComponent } from '../../manage-dialogue/manage-dialogue.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FWDetailsCellComponent } from '../../../table-cell/fw-details.component';
import { FwDetailsPopupComponent } from '../../fw-details-popup/fw-details-popup.component';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { CommonModule } from '@angular/common';
import { UpdateCyclePopupComponent } from '../../update-cycle-popup/update-cycle-popup.component';
import { LoaderComponent } from '../../../common-component/loader/loader.component';
import { FamilyCodeTransmissionService } from '../../../services/raintree/Transmission/familyCode-transmission.service';
import { ToastrService } from 'ngx-toastr';
import { ReviewService } from '../../../services/common/review-shared';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DpLoaderComponent } from '../../../common-component/dp-loader/dp-loader.component';
import { ManageUserReviewComponent } from '../../../table-cell/manage-user-review-cell.component';
import { distinctUntilChanged, forkJoin, of, Subscription } from 'rxjs';
import { AppComponent } from '../../../app.component';
import { AppConfigService } from '../../../services/config/app-config.service';
import { DistrictCellComponent } from '../../../table-cell/district-review-table';
import { StateCellComponent } from '../../../table-cell/state-review-table';
import { ReviewDataFilterPopupComponent } from '../../review-data-filter-popup/review-data-filter-popup.component';
import { ReviewDataComponent } from '../review-data.component';
import { StatusResolverService } from '../../../services/raintree/Transmission/status-resolver.service';
import { Permissions } from '../../../enum/permission';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SearchService } from '../../../services/common/search.service';
import { DADetailsCellComponent } from '../../../table-cell/da-detail.component';
@Component({
  selector: 'app-updated-data',
  standalone: true,
  imports: [
    DpTableComponent,
    CommonModule,
    LoaderComponent,
    InfiniteScrollModule,
    DpLoaderComponent, ReactiveFormsModule
  ],
  templateUrl: './updated-data.component.html',
  styleUrl: './updated-data.component.scss',
  providers: [ReviewDataComponent]
})
export class UpdatedDataComponent implements OnInit {
  responseData: any = [];
  constructor(
    private getstatusservice: StatusResolverService,
    private _activatedRoute: ActivatedRoute,
    private _appConfig: AppConfigService,
    private _reviewDataService: ReviewDataService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private isMobile: CommonUtilService,
    private toaster: ToastrService,
    private _searchService: SearchService,
    private familyCodeTransmissionService: FamilyCodeTransmissionService
  ) {
  }
  @ViewChild('tableContainer') tableContainer!: ElementRef;
  public districtName: any = '';
  public stateName: any = '';
  private pincode: string = '';
  public isMobileDevice: boolean = false;
  isLoading: boolean = false;
  isLoader: boolean = false;
  superUser: boolean = false;
  pgNo: number = 1;
  searchVal: any = { type: false };
  allDataLoaded: boolean = false;
  isScrollable: boolean = false;
  updateData: any;
  label: any;
  searchPgNo: number = 1;
  public tabLists: any = [];
  tempData: any = [];
  memKey: string = ''
  fwNames: any = [];
  finalPerm: any = []
  permission: any = [];
  searchReq = new FormControl('')
  statePresent: boolean = false
  districtPresent: boolean = false
  obj: any = {}
  daNames: any = [];
  fromDate: string = ''
  toDate: string = ''
  public displayColumnData: any = [
    {
      id: 'memberKey',
      name: 'Sl.no',
    },
    {
      id: 'fullName',
      name: 'Full name',
    },
    // {
    //   id: 'memStatus',
    //   name: 'Status',
    // },
    {
      id: 'memberFamilyCode',
      name: 'Family Code',
    },
    {
      id: 'updatedBy',
      name: 'Updated By',
    },
    {
      id: 'reviewedBy',
      name: 'Reviewed By'
    },

    {
      id: 'updatedAt',
      name: 'Updated on',
    },
    {
      id: 'currentStatus',
      name: 'Current Status',
    },
    {
      id: 'updateCount',
      name: 'Count',
    },
    {
      id: 'manageUser',
      name: '',
    },
  ];
  public displayStateColumnData: any = [
    {
      id: 'country',
      name: 'Country',
    },
    {
      id: 'stateName',
      name: 'State',
    },
    {
      id: 'pending',
      name: 'Count',
    },
  ];
  public displayColumnDataForDistrict: any = [
    {
      id: 'stateName',
      name: 'State',
    },
    {
      id: 'districtName',
      name: 'District',
    },
    {
      id: 'pending',
      name: 'Count',
    },
  ];
  columnConfs = {
    updateCount: { cssClass: 'listwidth' },
    memStatus: { cssClass: 'memberStatuswidth' },
    memberKey: { cssClass: 'slnowidth' },
  };
  cellComponentMap = {
    memberKey: SerialNoCellComponent,
    manageUser: ManageUserReviewComponent,
    memStatus: ActiveCellComponent,
    updatedAt: DateFormatCellComponent,
    updateCount: CountCellComponent,
    updatedBy: FWDetailsCellComponent,
    reviewedBy: DADetailsCellComponent,
  };
  cellComponentMapDistrict = {
    districtName: DistrictCellComponent,
    // state: StateCellComponent,
  };
  cellComponentMapState = {
    stateName: StateCellComponent,
  };
  ngOnInit(): void {
    this.isMobileDevice = this.isMobile.isMobileDevice();
    // this.permission = this._appConfig.fetchPermissionsByViewName();
    this.permission = this._appConfig.fetchPermissionv3ByViewName();
    console.log(this.permission);
    
    this.stateName = localStorage.getItem('review-state') ? localStorage.getItem('review-state') : ''
    this.districtName = localStorage.getItem('review-district') ? localStorage.getItem('review-district') : ''
    this.searchReq.valueChanges.subscribe((value: any) => {
      this.responseData = this.tempData;
      if (value?.length > 0) this.onSearch(value);
    });
    this.callApiService();
    this.subscribeToRouteParams()
  }
  subscribeToRouteParams(): void {
    this._activatedRoute.queryParams.subscribe((params) => {
      this.pgNo = 1
      this.searchReq.setValue('')
      if (params['state'] && params['district']) {
        this.districtName = params['district']
        this.stateName = params['state']
        this.obj = {
          uiState: this.stateName,
          uiDistrict: this.districtName
        }
        this.fetchUpdatedDataApi(true)
      } else if (params['state'] && !params['district']) {
        this.districtName = ''
        this.stateName = params['state']
        this.obj = {
          uiState: this.stateName
        }
        this.memKey = ''
        this.searchVal = {}
        this.fetchStateCount()
      }
      else if (!params['state'] && !params['district']) {
        this.stateName = this.districtName = ''
        this.obj = {}
        // this.router.navigate([], {
        //   relativeTo: this.route,
        //   queryParams: { country: 'India' },
        // });
        this.memKey = ''
        this.searchVal = {}
        this.fetchStateCount()
      }
      // else if (!params['country'] && !params['state'] && !params['district']) {
      //   this.router.navigate([], {
      //     relativeTo: this.route,
      //     queryParams: { country: 'India' },
      //   });
      // }
      this.fetchPermissions()
    }
    )
  }
  fetchPermissions() {
    this.finalPerm = [];
    const countryPerm = this.permission['INDIA'];
    if (this.stateName != '') {
      this.finalPerm = countryPerm?.allStatesPerm;
      const statePerm = countryPerm.statePerms[this.stateName];
      if (this.districtName != '' && statePerm) {
        this.finalPerm = [...this.finalPerm, ...statePerm?.allDistrictsPerm, ...statePerm?.districtPerms[this.districtName]];
      }
    } else {
      this.finalPerm = this.fetchPermName(this.permission)
    this.superUser =
      this.finalPerm.indexOf(Permissions.SuReview) !== -1 ? true : false;
      if(!this.superUser){
        this.displayColumnData = this.displayColumnData.filter((item:any) => item.id !== 'reviewedBy')
      }
      
    }
  }
  onSearch(value: any) {

    if (this.districtName === '' && this.stateName === '') {
      this.responseData = this._searchService.filterData(
        this.responseData,
        value,
        this.displayStateColumnData
      );
    }
    else if (this.stateName !== '' && this.districtName === '') {
      this.responseData = this._searchService.filterData(
        this.responseData,
        value,
        this.displayColumnDataForDistrict
      );
    } else if (this.stateName && this.stateName !== '') {
      this.responseData = this._searchService.filterData(
        this.responseData,
        value,
        this.displayColumnData
      );
    }
  }
  fetchPermName(perm: any, finalPermList: any = []) {
    Object.values(perm).forEach((item: any) =>
      Array.isArray(item) ? finalPermList.push(...item) : typeof item === 'object' && this.fetchPermName(item, finalPermList)
    );
    return [...new Set(finalPermList)];
  }
  openDistrictCount(event: any) {
    this.isLoader = true;
    if (event) {
      this.stateName = event.permanentState || event;
      // localStorage.setItem('review-state', this.stateName)
      this.districtName = event.permanentDistrict ?? ''
      let routeObj: any = {
        state: this.stateName
      }
      this.districtName !== '' ? routeObj.district = this.districtName : ''
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: routeObj,
        queryParamsHandling: 'merge',
      });
      // this.route.queryParams.subscribe((params) => {
      //   this.stateNamePresent = 'state' in params;
      // });
      this.obj = { uiState: this.stateName }
      // this.fetchStateCount();
    }
  }
  mobOnClick(rowData: any, type: string) {
    if (type === 'fw') rowData = { ...rowData, fw: true };
    else if (type === 'da') rowData = { ...rowData, da: true }
    else rowData = { ...rowData, count: true };
    this.openDialog(rowData);
  }
  openDialog(rowData: any) {
    if (rowData.fw) {
      this.dialog.open(FwDetailsPopupComponent, {
        data: {
          ...rowData,
          type: 'fw'
        }
      });
    }else if (rowData.da){
       this.dialog.open(FwDetailsPopupComponent, {
        data: {
          ...rowData,
          type: 'da'
        }
      });
    } else if (rowData.count) {
      this.isLoading = true;
      let reqData = {
        memKey: rowData.memberKey,
        fwUpdatedBy: rowData.updatedById,
      };
      this._reviewDataService.fetchUpdateCycle(reqData).subscribe({
        next: (res: any) => {
          if (res.data.length > 0) {
            this.isLoading = false;
            this.dialog.open(UpdateCyclePopupComponent, {
              data: res.data,
            });
          } else {
            this.isLoading = false;
            this.toaster.error('No update history found');
          }
        },
        error: (error: any) => {
          this.isLoading = false;
          this.toaster.error(error);
        },
      });
    } else if (rowData.memberFamilyCode && rowData.philMemberCode) {
      // this code is for adding latest iv date in the review data manage dialog
      this.isLoading = true
      this.familyCodeTransmissionService
        .getFamilyDetails(rowData.memberFamilyCode)
        .subscribe({
          next: (response: any) => {
            if (!response.error && response.data.length > 0) {
              // rowData.istData = response.data.find((item: any) => item.mem_name + ' ' + item.mem_surname === rowData.philFirstName + ' ' + rowData.philLastName)
              rowData.istData = response.data.find((item: any) => item.mem_key === rowData.philMemberCode)
            }
            this.openManageDialogue(rowData)
            this.isLoading = false
          },
          error: (error) => {
            this.isLoading = false
            this.openManageDialogue(rowData)
          },
        });
    } else {
      this.openManageDialogue(rowData)
    }
  }
  openManageDialogue(rowData: any) {
    const dialogRef = this.dialog.open(ManageDialogueComponent, {
      data: { data: rowData, state: this.stateName, district: this.districtName },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.isLoading = true;
        const index = this.responseData.findIndex(
          (item: { memberKey: any }) => item.memberKey === rowData.memberKey
        );
        if (index > -1) {
          this.responseData.splice(index, 1);
          this.isLoading = false;
        }
      }
    });
  }
  onFilterClick() {
    let queryParams = { ...this.route.snapshot.queryParams };
    if (queryParams['state'] && queryParams['district']) {
      this.isLoading = true;
      forkJoin({
        pinStatus: this._reviewDataService.fetchPinCode(
          this.stateName,
          this.districtName
        ),

        daStatus: this.superUser ? this._reviewDataService.fetchDANames({
           uiState: this.stateName,
          uiDistrict: this.districtName,
        }) : of(null),

        fwStatus: this._reviewDataService.fetchFWNames({
          uiState: this.stateName,
          uiDistrict: this.districtName,
        }),
      

      }).subscribe({
        next: (response) => {
           this.isLoading = false;
          this.pincode =
            response.pinStatus.data.length > 0
              ? response.pinStatus.data.map(
                (item: { pincode: any }) => item.pincode
              )
              : [];
          this.fwNames =
            response.fwStatus.data.length > 0
              ? response.fwStatus.data.map(
                (item: { first_name: string; last_name: string; id: string }) => {
                  return {
                    name: item.first_name + ' ' + item.last_name,
                    id: item.id
                  }
                }
              )
              : [];
          this.daNames = 
              response.daStatus?.data.length > 0 
                ? response.daStatus.data.map(
                  (item: { first_name: string; last_name: string; id: string }) => {
                  return {
                    name: item.first_name + ' ' + item.last_name,
                    id: item.id
                  }
                }
                )
                : []
          this.openDialogFilter();
         
        },
        error: (error) => {
          this.toaster.error(error);
          this.isLoading = false;
        },
      });
    } else
      this.openDialogFilter();
  }
  openDialogFilter() {
    
    const dialogRef = this.dialog.open(ReviewDataFilterPopupComponent, {

      data: {
        fromDate: this.fromDate,
        toDate: this.toDate,
        superUser: this.superUser,
        pinList: this.pincode ?? '',
        fw: this.fwNames ?? '',
        da: this.daNames ?? '',
        fc: this.searchVal?.fc ?? '',
        sortByDate: this.searchVal?.sortByDate ?? '',
        slNo: this.memKey ? this.memKey : this.searchVal.serialNumber ?? '',
        pin: this.searchVal?.pincode ?? '',
        status: this.searchVal?.status ?? '',
        reviewStatus: this.searchVal?.reviewStatus ?? '',
        fwName: this.searchVal?.updatedByFW ?? '',
        daName: this.searchVal?.reviewedByDA ?? ''
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value.type && value.showAllFilter) {
        this.searchVal = value
        console.log(this.searchVal);
        this.fromDate = this.searchVal.fromDate
        this.toDate = this.searchVal.toDate
        
        !value.serialNumber ? this.memKey = '' : ''
        this.fetchUpdatedDataApi(true)
      }
      else if (value.type && !value.showAllFilter && value.serialNumber !== '') {
        this.searchVal = value
        this.fetchDetailsBySlNo(value.serialNumber);
        // } else {
        //   this.searchVal = {}
        //   this.memKey = ''
      }
    });
  }
  fetchDetailsBySlNo(item: any) {
    this.memKey = item
    this._reviewDataService.fetchDetailsBySlNo(item).subscribe({
      next: (response: any) => {
        this.openDistrictCount(response.data[0])
      },
      error: (err: any) => {
        this.toaster.error(err)
      }
    })
  }
  statusMap: any = []
  callApiService() {
    this.getstatusservice.getStatusData().subscribe({
      next: (response: any) => {
        this.statusMap = new Map(
          response.data.map(
            (item: { status_code: any; status_desc: any }) => [
              item.status_code,
              item.status_desc,
            ]
          )
        );
        // if (next_func) next_func();
      },
      error: (error: any) => {
        this.isLoader = false;
        this.toaster.error(error);
      },
    });
  }
  ngAfterViewInit() {
    this.tableContainer?.nativeElement.addEventListener(
      'scroll',
      this.onScroll.bind(this)
    );
  }
 
  onScroll() {
    if (this.isScrollable) {
      this.pgNo++;
      this.fetchUpdatedDataApi(false);
    }
  }
  openDataTable(event: any) {
    if (event) {
      this.districtName = event;
      // localStorage.setItem('review-district', this.districtName)
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { district: this.districtName },
        queryParamsHandling: 'merge',
      });
      this.obj.uiDistrict = this.districtName
      // this.showSearch = true;
      // this.onDistrictURLChange();
      // this.fetchUpdatedDataApi()
    }
  }
  fetchStateCount() {
    this.isLoader = true
    this._reviewDataService.fetchStateCount(this.obj).subscribe(
      (res) => {
        if (this.stateName !== '')
          this.responseData = this.tempData = res.data
        else
          this.responseData = this.tempData = res.data.map((item: any) => ({ ...item, country: 'India' }));
        this.isLoader = false
      },
      (error) => {
        this.isLoader = false
        this.toaster.error(error);
      }
    );
  }
  private fetchUpdatedDataApi(scrollable: boolean): void {
    if (scrollable && this.pgNo === 1) this.isLoader = true
    if (scrollable) {
      this.pgNo = 1;
      this.isScrollable = true;
    }
    if (!scrollable && this.pgNo > 1) this.isLoading = true;
    this.obj = {
      uiState: this.stateName,
      uiDistrict: this.districtName,
      pageNo: this.pgNo,
    };
    if (this.searchVal?.type) {
      this.obj = { ...this.obj, ...this.searchVal }
      delete this.obj.type
      delete this.obj.showAllFilter
    }
    //  else
    //   this.memKey = ''
    console.log(this.searchVal)
    this._reviewDataService.fetchupdatedData(this.obj).subscribe(
      (res) => {
        if (res.data.length === 0) this.allDataLoaded = true;
        this.responseData = res.data;
        this.responseData = this.responseData.map(
          (item: { recordStatus: any }) => {
            if (this.statusMap.has(item.recordStatus)) {
              return {
                ...item,
                currentStatus: this.statusMap.get(item.recordStatus),
                manageUser: 'Manage'
              };
            }
            return item;
          }
        );
        if (this.pgNo > 1
        )
          this.responseData = [...this.tempData, ...this.responseData];
        this.tempData = this.responseData;
        this.isLoader = this.isLoading = false;
        console.log("responseData",this.responseData);
        
      },
      (error) => {
        this.isLoader = this.isLoading = false;
        this.toaster.error(error);
      }
    );
  }
}
